export const createEmpty2dArray = (length: number) => {
  return new Array(length).fill(null).map((x) => new Array());
};

export const createFilled2dArray = <Type>(width: number, height: number, filledValue: Type): Type[][] => {
  return new Array(height).fill([]).map((x) => new Array(width).fill(filledValue));
};

// helper to push element to an array with an array size constraint
// the first element of the array is dropped if inserting the new element makes the size go above the specified max length
export const pushSliding = <Type>(array: Type[], newElement: Type, maxLength: number) => {
  array.push(newElement);
  if (array.length > maxLength) {
    array.shift();
  }
};

export const arraysEqual = <Type>(a1: Type[], a2: Type[]): boolean => {
  return a1.length === a2.length && a1.every((v, i) => v === a2[i]);
};
